import classNames from "classnames";

import { BaseLayout } from "components/BaseLayout/BaseLayout";

import { Header, ProductsGroupList, ProductsGroupFooter } from "./components";
import styles from "./styles.module.scss";

export const ProductsGroup = (): JSX.Element => (
  <BaseLayout
    className={classNames("ml-2 mt-3 mb-3", styles.container)}
    header={<Header />}
    footer={<ProductsGroupFooter />}
  >
    <ProductsGroupList />
  </BaseLayout>
);
